import { forwardRef } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";

export const PricingSection = forwardRef<HTMLDivElement>((_, ref) => (
  <section ref={ref} className="space-y-8">
    <div className="text-center space-y-2">
      <h2 className="text-2xl font-display font-bold">
        Velg nivået som passer familien deres
      </h2>
    </div>
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
      {/* Flyt Gratis */}
      <Card className="border-2 border-[hsl(var(--success))]">
        <CardContent className="p-6 space-y-4">
          <div className="space-y-1">
            <span className="inline-flex items-center rounded-full bg-[hsl(var(--success))]/10 px-2.5 py-0.5 text-xs font-semibold text-[hsl(var(--success))]">
              Gratis
            </span>
            <p className="font-display font-bold text-lg">Flyt Gratis</p>
            <p className="text-sm font-semibold text-foreground">Struktur for hverdagen</p>
          </div>
          <ul className="space-y-2 text-sm">
            {[
              "Ubegrenset antall barn",
              "Dagens gjøremål",
              "Fremgang i dag",
              "7 dagers historikk",
              "Barn trenger ikke e-post",
            ].map((item) => (
              <li key={item} className="flex items-start gap-2">
                <span className="text-[hsl(var(--success))] mt-0.5">✓</span>
                {item}
              </li>
            ))}
          </ul>
          <Button className="w-full" asChild>
            <Link to="/register">Kom i gang gratis</Link>
          </Button>
        </CardContent>
      </Card>

      {/* Flyt Pluss */}
      <Card className="border-2 border-primary shadow-lg bg-primary/5">
        <CardContent className="p-7 space-y-4">
          <div className="space-y-1">
            <span className="inline-flex items-center rounded-full bg-primary/10 px-2.5 py-0.5 text-xs font-semibold text-primary">
              Mest valgt
            </span>
            <p className="font-display font-bold text-lg">Flyt Pluss</p>
            <p className="text-sm font-semibold text-foreground">79 kr/mnd · per forelder</p>
            <p className="text-sm font-semibold text-foreground">Struktur og motivasjon</p>
          </div>
          <p className="text-sm text-muted-foreground">For deg som vil ha bedre oversikt. Se barnets fremgang, bygg gode vaner og skap mer flyt i hverdagen.</p>
          <ul className="space-y-2 text-sm">
            {[
              "Alt i Gratis",
              "Full historikk og utvikling over tid",
              "Poengsystem og belønninger",
              "AI-hjelp til å lage gode oppgaver",
              "Tydelig fremgang du kan følge",
            ].map((item) => (
              <li key={item} className="flex items-start gap-2">
                <span className="text-primary mt-0.5">✓</span>
                {item}
              </li>
            ))}
          </ul>
          <Button className="w-full" asChild>
            <Link to="/register?plan=plus">Prøv Pluss (14 dager)</Link>
          </Button>
        </CardContent>
      </Card>

      {/* Flyt Sammen */}
      <Card className="border-2 border-border">
        <CardContent className="p-6 space-y-4">
          <div className="space-y-1">
            <p className="font-display font-bold text-lg">Flyt Sammen</p>
            <p className="text-sm font-semibold text-foreground">99 kr/mnd · aktiveres per familie</p>
            <p className="text-sm font-semibold text-foreground">Samarbeid og konsistens</p>
          </div>
          <p className="text-sm text-muted-foreground">For to foreldre som vil stå samlet. Felles oversikt, tydelig ansvar og en struktur barnet kan stole på – hver dag.</p>
          <ul className="space-y-2 text-sm">
            {[
              "Alt i Pluss",
              "Felles foreldredashboard",
              "Oversikt over hvem som følger opp hva",
              "Tydelig ansvarsfordeling",
              "Barnet møter én samlet og forutsigbar struktur",
            ].map((item) => (
              <li key={item} className="flex items-start gap-2">
                <span className="text-primary mt-0.5">✓</span>
                {item}
              </li>
            ))}
          </ul>
          <p className="text-sm text-muted-foreground italic">Når dere står samlet, slipper barnet å forhandle om forventningene.</p>
          <Button className="w-full" asChild>
            <Link to="/register?plan=together">Velg Sammen</Link>
          </Button>
        </CardContent>
      </Card>
    </div>
  </section>
));

PricingSection.displayName = "PricingSection";
